import React from 'react';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';
import TooltipNew from '../TooltipNew';
import typeOf from '../../helpers/typeOf';

const DataComponentTableHeader = ({
    multiLevelHeaderNames = [],
    headerNames = [],
    columnData = {}
}) => {
    const renderHint = (hint, key) => {
        if (!hint) return null;

        return (
            <TooltipNew id={key} tooltip={hint} />
        );
    };

    const headerNamesArray = Array.isArray(headerNames) ? headerNames : Object.values(headerNames || {});
    if (!multiLevelHeaderNames.length && !headerNamesArray.length) return null;

    return (
        <thead>
            {!multiLevelHeaderNames.length
                ? (
                    <tr className="bold">
                        {headerNamesArray.map((item, i) => {
                            const data = columnData[i] || {};
                            let value = item;
                            let hint = '';

                            if (typeOf.isObject(item)) {
                                if (!item.disabled && !item.visible) return null;
                                value = item.title;
                                hint = item.hint;
                            }
                            return <th key={i} {...data}>{typeOf.isString(value) ? Parser(value) : value} {renderHint(hint, i)}</th>
                        })}
                    </tr>
                )
                : multiLevelHeaderNames.map((items, i) => (
                    <tr key={i} className="bold">
                        {items.map((item, j) => (
                            <th
                                key={j}
                                colSpan={item.colspan}
                                rowSpan={item.rowspan}
                            >{item.value}</th>
                        ))}
                    </tr>
                ))
            }
        </thead>
    );
};

DataComponentTableHeader.propTypes = {
    multiLevelHeaderNames: PropTypes.array,
    headerNames: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    columnData: PropTypes.object
};

export default DataComponentTableHeader;
